export const locale = {
    lang: 'en',
    data: {
        'NAV': {
            'QUOTES': 'Quotes',
            'QUOTE'        : {
                'TITLE': 'Quote',
                //'BADGE': '25'
            },
            'MYQUOTES'        : {
                'TITLE': 'My quotes',
                //'BADGE': '2'
            },
            'MYORDERS'        : {
                'TITLE': 'My orders',
                //'BADGE': '2'
            },
           
            
        }
    }
};
